import AboutUs from '../containers/AboutUs';

export default AboutUs;
